import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output
} from '@angular/core'

/**
 * A simple checkbox component for indicating selection.
 */
@Component({
  selector: 'vdr-select-toggle',
  templateUrl: './select-toggle.component.html',
  styleUrls: ['./select-toggle.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SelectToggleComponent {
  @Input() selected = false
  @Input() disabled = false
  @Input() label: string | undefined
  @Output() selectedChange = new EventEmitter<boolean>()
}
